import { gql } from "@apollo/client";

export const GET_AUTORIZACIONES_BOT = gql`
query GetAutorizacionesBOT($filters: ReporteBOTFilterInput!){
  autorizacionesBOT(filters: $filters) {
    success,
    error,
    valorEsperado {
      idReporte
      delegacion
      tipoCorreo
      mailOrigen
      eV
      paciente
      hC
      asunto
      adjunto
      estado
      fechaalta
    }
  }            
}`;